<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { toValue, type MaybeRefOrGetter } from 'vue';
import FontAwesomeIcon from './FontAwesomeIcon.vue';
import TmlButton from './TmlButton.vue';

export type Action = {
  label: string;
  icon: IconDefinition;
  type?: 'danger'; // 'success' | 'warning'
  disabled?: MaybeRefOrGetter<boolean>;
  handler: () => void;
};

defineProps<{
  actions: Action[];
}>();
</script>

<template>
  <TmlButton
    v-for="action in actions"
    :key="action.label"
    class="dropdown-action"
    :disabled="toValue(action.disabled)"
    :style="{
      color: action.type ? `var(--tml-${action.type}-color)` : undefined,
    }"
    @click="action.handler"
  >
    <span class="flex items-center">
      <Transition name="fade" mode="out-in">
        <FontAwesomeIcon :key="action.icon.iconName" class="w-4 h-4 mr-3" :icon="action.icon" />
      </Transition>
      {{ action.label }}
    </span>
  </TmlButton>
</template>

<style scoped>
.dropdown-action {
  @apply w-full text-left py-2 px-4 whitespace-nowrap min-w-[180px];
  @apply text-[--tml-dropdown-action-text-color] hover:text-[--tml-dropdown-action-hover-text-color];
  @apply bg-[--tml-dropdown-action-background-color] hover:bg-[--tml-dropdown-action-hover-background-color];
}
</style>
